/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Offset_TypeInputs */

const en_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset Type`)
};

const fr_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de décalage`)
};

const de_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset-Typ`)
};

const it_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di offset`)
};

const ru_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип смещения`)
};

const es_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de desplazamiento`)
};

const zh_cn2_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏移类型`)
};

const ja_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセットタイプ`)
};

const hi_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफसेट प्रकार`)
};

const pt_pt2_subtitle_export_offset_type = /** @type {(inputs: Subtitle_Export_Offset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de deslocamento`)
};

/**
* | output |
* | --- |
* | "Offset Type" |
*
* @param {Subtitle_Export_Offset_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_offset_type = /** @type {((inputs?: Subtitle_Export_Offset_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Offset_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_offset_type(inputs)
	if (locale === "de") return de_subtitle_export_offset_type(inputs)
	if (locale === "it") return it_subtitle_export_offset_type(inputs)
	if (locale === "ru") return ru_subtitle_export_offset_type(inputs)
	if (locale === "es") return es_subtitle_export_offset_type(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_offset_type(inputs)
	if (locale === "ja") return ja_subtitle_export_offset_type(inputs)
	if (locale === "hi") return hi_subtitle_export_offset_type(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_offset_type(inputs)
	return en_subtitle_export_offset_type(inputs)
});